var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.964 19.372H16.668V27.588H20.048V19.372H23.428V15.992H20.048V14.276C20.048 13.9987 20.1173 13.756 20.256 13.548C20.3947 13.34 20.5507 13.236 20.724 13.236H23.428V9.908H20.724C19.6147 9.908 18.6613 10.3413 17.864 11.208C17.0667 12.0747 16.668 13.1147 16.668 14.328V15.992H13.964V19.372ZM18.696 37C16.1653 37 13.7907 36.532 11.572 35.596C9.35333 34.6253 7.412 33.3253 5.748 31.696C4.11867 30.032 2.81867 28.0907 1.848 25.872C0.912 23.6533 0.444 21.2787 0.444 18.748C0.444 16.2173 0.912 13.8427 1.848 11.624C2.81867 9.40533 4.11867 7.464 5.748 5.8C7.412 4.136 9.35333 2.836 11.572 1.9C13.7907 0.929333 16.1653 0.444 18.696 0.444C21.2267 0.444 23.6013 0.929333 25.82 1.9C28.0387 2.836 29.9627 4.136 31.592 5.8C33.256 7.464 34.556 9.40533 35.492 11.624C36.4627 13.8427 36.948 16.2173 36.948 18.748C36.948 21.2787 36.4627 23.6533 35.492 25.872C34.556 28.0907 33.256 30.032 31.592 31.696C29.9627 33.3253 28.0387 34.6253 25.82 35.596C23.6013 36.532 21.2267 37 18.696 37Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.02fa7f527ddd2754c2f93cd949ce3d9d.svg";
export { ForwardRef as ReactComponent };